<template>
<el-form :model="formPlan" ref="formPlan" :label-position="'top'">

    <el-form-item class="custom-label" label="Selecciona tu fecha de visita y los servicios alquilar" prop="fecha_visita" :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
        ]">
        <el-date-picker v-model="formPlan.fecha_visita" type="date" placeholder="Seleccione un día" format="dd/MM/yyyy" @change="getTickets">
        </el-date-picker>

    </el-form-item>

    <div class="mt-4">

    </div>

    <el-alert v-if="listTickets.length==0 && formPlan.fecha_visita != null" title="No se encontrarón productos disponibles para la fecha seleccionada" type="error" class="mb-4">
    </el-alert>

    <!--Entradas pagadas-->
    <div v-if="listTickets.length>0" class="row mt-4">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" class="th">Servicio</th>
                    <th scope="col" class="th"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in listEventos" :key="index">
                    <td>{{item.name}}</td>
                    <td>
                        <el-button type="success" round size="small" icon="el-icon-shopping-cart-2" class="btn-block"
                        @click="agregar(item)">más detalles</el-button>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>

    <div class="d-flex justify-content-between">
        <!--<button v-if="listPiscinas.length>0" class="btn btn-warning mb-3 mt-3 ml-2" style="border-radius:50px" @click.prevent="dialogServices = true">+ Agregar servicios</button>
        -->

        <div class="">
            <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">Atras</button>
            <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formPlan')">Siguiente</button>
        </div>

    </div>

    <el-dialog :visible.sync="dialogVisible" center top="1vh" title="Detalles">

<div class="row">
  <div class="col-sm-12">
      <table border="1" width="100%">
        <tr>
                <td>Evento</td>
                <td>{{item.name}}</td>
              </tr>
        <tr>
          <td>Zona</td>
          <td>

            <el-select v-model="value" placeholder="Select" @change="getDetails">
                <el-option v-for="(row, index) in item.zonas" :key="index"
                  :label="row.name"
                  :value="row.id">
                </el-option>
            </el-select>

          </td>
        </tr>

        <tr>
          <td>Capacidad</td>
          <td>{{itemZona.capacidad}}</td>
        </tr>
        <tr>
          <td>Importe</td>
          <td>{{itemZona.precio}}</td>
        </tr>

      </table>
  </div>
</div>
      <div class="row">
<el-tabs v-model="lugar">
    <el-tab-pane label="Ubicación" name="second">
      <img src="https://img.remediosdigitales.com/320f5c/mapa-mex_650/1366_2000.jpg" alt="">
    </el-tab-pane>
    <el-tab-pane label="Imagenes" name="third">
      <img v-if="itemZona.id == 'z1'" src="https://apv.serpar.gob.pe/writable/uploads/zonas/img1.jpg" height="400px" />
      <img v-if="itemZona.id == 'z2'" src="https://apv.serpar.gob.pe/writable/uploads/zonas/img2.jpg" height="400px" />
      <img v-if="itemZona.id == 'z3'" src="https://apv.serpar.gob.pe/writable/uploads/zonas/img3.jpg" height="400px" />
    </el-tab-pane>
	<el-tab-pane label="Más detalles" name="tree">
      <ul>
        <li>11 x 6 m - 70 x 85 m de extensión</li>
        <li>referencia: Estrado - Explanada Central (zona de camping)</li>
        <li>Disponibilidad sujeto a terminos y condiciones</li>
      </ul>
    </el-tab-pane>
  </el-tabs>



      </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary" icon="el-icon-shopping-cart-2" @click="addCarrito">Seleccionar</el-button>
        </span>
    </el-dialog>

    <el-dialog title="Agregar servicios adicionales a mi compra" :visible.sync="dialogServices" width="50%" @opened="openedServices">
        <!--<el-alert title="Seleccione un turno haciendo clic en la opción [Agregar]" type="success" show-icon class="mb-3">
        </el-alert>-->
        <div class="row">
            <label class="col-sm-3"><b>Fecha de visita:</b> </label>
            <label class="col-sm-9 text-primary font-weight-bold h5">{{getDateVisit}} </label>
        </div>
        <hr>
        <div class="row">
            <el-tabs :tab-position="'left'" style="height: 200px;">
                <el-tab-pane>
                    <div class="d-flex flex-column align-items-center" slot="label">
                        <img :src="'/static/logos/iconpiscina.png'" width="auto" height="80" alt="logo">
                        <!--<i class="el-icon-date"></i>-->
                        <span>Piscina</span>
                    </div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col" class="th">Servicio</th>
                                <th scope="col" class="th" style="width:80px;">Precio</th>
                                <th scope="col" class="th">Opción</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in listPiscinas" :key="index">
                              <td>{{item.productoDescripcion}}</td>
                              <td>s/ {{item.pUnitario.toFixed(2)}}</td>
                              <td>
                                  <el-button type="success" round size="small" icon="el-icon-shopping-cart-2" class="btn-block" @click="agregar(item)">Agregar</el-button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </el-tab-pane>
                <!--<el-tab-pane label="Config">Config</el-tab-pane>-->
            </el-tabs>
        </div>

        <!--<div class="row">
            <label class="col-sm-3"><b>Servicio de piscina:</b> </label>
            <el-select v-model="piscinaId" placeholder="Seleccione" size="small" class="col-sm-9">
                <el-option v-for="(item, index) in listPiscinas" :key="'P'+index" :label="item.productoDescripcion" :value="item.productoId"></el-option>
            </el-select>
        </div>-->

        <!--<table class="table table-bordered mt-4">
            <colgroup>
                <col class="col-sm- col-md-2">
                <col class="col-md-3">
                <col class="col-md-3">
                <col class="col-md-2">
                <col class="col-md-2">
            </colgroup>
            <tr class="bg-gray-100 text-center">
                <th class="align-middle">Turno</th>
                <th>Inicia</th>
                <th>Termina</th>
                <th>Aforo</th>
                <th>***</th>
            </tr>
            <tbody>
                <tr v-for="(item,index) in listTurnos" :key="'S'+index">
                    <td>{{item.item}}</td>
                    <td>{{item.horaInicio}}</td>
                    <td>{{item.horaFin}}</td>
                    <td>{{item.disponible}} de {{item.aforo}}</td>
                    <td>
                        <el-button type="success" round size="small" icon="el-icon-shopping-cart-2" class="btn-block" @click="agregar(item)">Agregar</el-button>
                    </td>
                </tr>
            </tbody>
        </table>-->

    </el-dialog>

</el-form>
</template>

<script>
//services
import services from "@/services/services.service";
import moment from "moment";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

import {
    mapGetters
} from 'vuex'

export default {
    props: {
        club: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data: () => ({
        formPlan: {
            fecha_visita: null,
        },
        listTickets: [],
        listCarrito: [],
        listTurnos: [],
        listPiscinas: [],
        piscinaId: null,
        dialogVisible: false,
        numero: 1,
        item: {},
        isFree: false,
        listTicketsFree: [],
        dialogServices: false,
        value: "",
        lugar: 'second',
        itemZona: {},
        listEventos: [
          {id: 1, name: "Aniversarios",
            zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]
          },
          {id: 2, name: "Cumpleaños",
            zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]},
          {id: 3, name: "Eventos de promoción", zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]},
          {id: 4, name: "Matrimonios", zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]},
          {id: 5, name: "Quinceañeros", zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]},
          {id: 6, name: "Revelación de Sexo del bebe", zonas: [
              {id: "z1", name: "Zona 1", capacidad: "100 personas", precio: "500"},
              {id: "z2", name: "Zona 2", capacidad: "500 personas", precio: "600"},
              {id: "z3", name: "Zona 3", capacidad: "800 personas", precio: "700"}
            ]},
        ]
    }),
    computed: {
        ...mapGetters(['totalPagar', 'getDateVisit'])

    },
    methods: {
        volver() {
            this.$emit("resVolver", 1)
        },

        async getTickets() {

            let hoy = moment().format('YYYY-MM-DD')
            let current = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD')

            if (current < hoy) {
                this.formPlan.fecha_visita = null
                this.listTickets = []
                this.listTicketsFree = []
                alert("No puede seleccionar una fecha anterior.")

            } else {

                if (current == '2023-12-24' || current == '2023-12-31') {
                    alert("Lo sentimos, en estas fechas no atenderemos. Gracias por tu comprensión")
                    this.formPlan.fecha_visita = null
                    this.listTickets = []
                    this.listTicketsFree = []
                    return false
                }

                let date_visit = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD[T]00:00:00')
                this.listTickets = []
                this.listCarrito = []
                this.listTicketsFree = []

                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

                //entradas pagadas
                await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "001",
                    "inicio": date_visit
                }).then((res) => {
                    this.listTickets = res.data
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })

                //entradas gratis
                await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "006",
                    "inicio": date_visit
                }).then((res) => {
                    this.listTicketsFree = res.data
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })

                //piscina
                await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "008",
                    "inicio": date_visit
                }).then((res) => {
                    this.listPiscinas = res.data
                    console.log(this.listPiscinas)
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })

                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");

                this.$store.dispatch("updateDateVisit", moment(date_visit).format('DD/MM/YYYY'));
                this.$store.dispatch("updateCarrito", this.listCarrito);

            }

        },

        async openedServices() {
            //estableciendo el primer registro en el select
            if (this.listPiscinas.length > 0) {
                this.piscinaId = this.listPiscinas[0].productoId
            }

            //consultar turnos
            let fechaInicio = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD[T]00:00:00')
            await axios.post(`${process.env.API2}/v1/piscina/listarProgramacion`, {
                "ue": "001066",
                "sede": "001",
                "area": this.club.idseat,
                "fechaInicio": fechaInicio
            }).then((res) => {
                this.listTurnos = res.data
            })
        },

        agregar(item) {
            this.item = this.listEventos.find(element => element.id === item.id)
            //console.log(item)
            this.numero = 0

            this.dialogVisible = true
        },

        getDetails() {
          console.log(this.value)
          if(this.item.zonas)
            this.itemZona = this.item.zonas.find(element => element.id === this.value)

          //return oks;
          //return this.item.zonas.find(element => element.id === value)
        },

        addCarrito() {

                /*let _codigo = null
                let _turno = null

                if (this.dialogServices) {
                    _codigo = this.item.productoId
                    _turno = this.item.item
                }*/

                let tmpcar = {
                    item: (1),
                    areaId: this.club.idseat,
                    producto: this.item.id,
                    descripcionProducto: this.item.name,
                    precioUnitario: this.itemZona.precio,
                    cantidad: 1,
                    total: parseInt(this.itemZona.precio),
                    /*codigo: _codigo,
                    turno: _turno*/
                }
                this.listCarrito.push(tmpcar)
                this.$store.dispatch("updateCarrito", this.listCarrito);
                console.log(this.listCarrito)

            this.dialogVisible = false
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false

                if (this.listCarrito.length > 0) {
                    if (this.totalPagar <= 0)
                        alert("El monto no puede 0")
                    else
                        this.$emit('resCarrito', this.listCarrito)
                } else
                    alert("Su carrito se encuentra vacío, por favor agrege productos a su cesta.")
            })
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/concesiones/Alquileres.vue